'use strict';
var $ = require('jquery');
var resultsView = require('./results_view');
var questionView = require('./question_view');
var basepath = require('./basepath'); 
var $intro = $('.intro-container');
var $getStartedButtons = $('.get-started-button');
var $questionContainer = $('.questions-container');
var $questionsContainerInner = $('.questions-container-inner');

var $landingImageContainer = $('.intro-background-image-container');
var $landingImage = $landingImageContainer.find('img');

var $callCTAText = $('.call-cta-text');
// var $getStartedIndividual = $('.get-started-individual');
// var $getStartedBusiness = $('.get-started-business');

// var $bannerCTAIntro = $('.header-banner-start-cta');
var $bannerCTACall = $('.header-banner-call');

$('.questions-container-footer').hide();


//
var beginCallback;
var answerSelectCallback;
var nextCallback;
var previousCallback;
var whyCallback;
//
var questionViews = [];
var results;
//



$(window).scroll(function() {
    var topEdge = $(this).scrollTop();
    var bottomEdge = $('.results-contact-cta').offset().top;

    if (results){
        results.containSticky(topEdge, bottomEdge);
    }
});

var landingImagesArray;
function setRandomLandingImage() {
    if (!landingImagesArray || !landingImagesArray.length) {
        return;
    }

    var imgIndex = Math.floor(Math.random() * landingImagesArray.length);
    var img = landingImagesArray[imgIndex];
    setLandingImage(img);
}

function setLandingImage(src) {
    $landingImage.hide();
    $landingImageContainer.find('img').attr('src', basepath.getPath(src));
}
function init(landingImages) {
    $getStartedButtons.attr('disabled', 'disabled');



    $('.hide-chairs-list').on('click', function() {
        $('.available-chairs-container').fadeOut();
    });


    function begin(track) {

        beginCallback(track);
    }
    $('.js-start-business').on('click', function() {
        begin('business');
    });

    $('.js-start-individual').on('click', function() {
        begin('personal');
    });

    $landingImage.hide();
    $landingImage.bind('load', function () {
        $(this).fadeIn();
    });

    landingImagesArray = landingImages;
    setRandomLandingImage();

}

function buildQuestionPages(questions) {

    questions.allQuestions.forEach(function(question, index) {
        var newView = questionView(question, index);

        newView.onAnswerSelect(function(questionAndAnswer) {
            if (!!answerSelectCallback) {
                answerSelectCallback(questionAndAnswer);
            }
        });
        newView.onNext(function() {
            if (!!nextCallback) {
                nextCallback();
            }
        });

        newView.onPrevious(function() {
            if (!!previousCallback) {
                previousCallback();
            }
        });

        newView.onWhy(function(body, query) {
            if (whyCallback) {
                whyCallback(body, query);
            }
        });

        $questionsContainerInner.append(newView.$el);

        questionViews.push(newView);
    });
}


var totalQuestions;
var api = {
    start: function(questions, landingImages) {
        init(landingImages);
        buildQuestionPages(questions);
        $getStartedButtons.removeAttr('disabled');
    },
    clearResults: function () {
        $('.results-chairs-container').html('');
        $('.results-shop-chairs-container').html('');
        $('.results-container').hide();
        $('html,body').animate({
            scrollTop: 0
        }, 0);

        results = null;
    },
    beginQuestions: function(_totalQuestions) {
        this.clearResults();
        $callCTAText.html('Need help answering any questions?');
        // $bannerCTAIntro.hide();
        // $bannerCTAIntro.addClass('hide-intro-cta');

        $bannerCTACall.fadeIn('fast');
        totalQuestions = _totalQuestions;
        //Hero occupies same space as the questions. Hide it. 
        $('.js-intro-hero').hide();
    },
    showIntro: function() {
        setRandomLandingImage();
        $callCTAText.html('Need help answering any questions?');
        // $bannerCTAIntro.fadeIn('fast');
        // $bannerCTAIntro.removeClass('hide-intro-cta');


        $bannerCTACall.hide();
        //Hero occupies same space as the questions. Hide it. 
        $('.js-intro-hero').show();

        $intro.fadeIn();
        $questionContainer.hide();
        
    },
    showResults: function(linkHash) {

        $callCTAText.html('Need help deciding?');
        // $bannerCTAIntro.addClass('hide-intro-cta');
        $bannerCTACall.fadeIn('fast');

        $intro.hide();
        $questionContainer.hide();
        $('.results-container').fadeIn();
    },
    
    displayChairDetails: function(chairDetails) {
        results = resultsView.make(chairDetails);
        var $tableEl = results.$tableEl;
        var $shopChairs = results.$shopChairs;
        var $resultsStickyContent = results.$resultsStickyContent;

        $('.results-sticky').html('');
        $('.results-sticky').html($resultsStickyContent);

        $('.results-chairs-container').html('');
        $('.results-chairs-container').append($tableEl);

        $('.results-shop-chairs-container').html('');
        $('.results-shop-chairs-container').append($shopChairs);

        results.handleAppended();
        
        $('html,body').animate({
            scrollTop: 0
        }, 0);
    },
    setToPersonalTrack: function(doSetToPersonal) {
        questionViews.forEach(function(view) {
            view.updatePersonalTrack(doSetToPersonal);
        });
    },
    enableView: function(questionID, currentQuestionIndex, dontScrollOnStart, resetAnswerOfCurrentQuestion) {
        $intro.hide();
        $questionContainer.fadeIn();

        questionViews.forEach(function(view) {
            var isCurrentView = view.id === questionID;

            view.enabled(isCurrentView, currentQuestionIndex, dontScrollOnStart, totalQuestions, resetAnswerOfCurrentQuestion);
        });
    },
    //
    onWhy: function(callback) {
        whyCallback = callback;
    },
    
    onRestart: function(callback) {

        resultsView.onRestart(function() {
            callback();
        });
    },
    onBegin: function(callback) {

        beginCallback = callback;
    },
    onAnswerSelect: function(callback) {
        answerSelectCallback = callback;
    },
    onNext: function(callback) {
        nextCallback = callback;
    },
    onPrevious: function(callback) {
        previousCallback = callback;
    },
    showSticky: function(doShow) {
        // console.log('showSticky', results);
        if (results) {
            results.showSticky(doShow);
        }
    }
};

module.exports = api;